<template>
  <thead>
    <tr>
      <th v-for="item in columns" :width="item.width" :align="item.align || 'left'" :key="item.prop" :style="{
        'min-width': `${item['min-width']}`,
        'max-width': `${item['max-width']}`
      }" v-html="item.label"></th>
    </tr>
  </thead>
</template>
 
<script>
export default {
  name: 'tableHeader',
  props: {
    columns: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    renderToHtml(col) {
      if (typeof col.render === 'function') {
        this.$slots[col.prop] = [col.render(row)];
        return;
      }
      return;
    }
  }
};
</script>
 
<style scoped>
th {
  font-weight: bold;
  padding: 0.09rem 0.02rem;
  background: #f7f9f9;
  color: #8695a1;
  word-wrap: break-word;
  word-break: break-all;
}
</style>